<div class="flex-column hidden-overflow">
  @if (_data.iconType === 'warning') {
    <span class="material-symbols-outlined warning-icon" align="center">warning_amber</span>
  } @else if (_data.iconType === 'info') {
    <span class="material-symbols-outlined info-icon" align="center">info</span>
  } @else if (_data.iconType === 'error') {
    <span class="material-symbols-outlined error-icon" align="center">error</span>
  }
  <mat-dialog-content class="dialog-content-align">
    @if (typeof _data.message === 'string') {
      <span [innerHTML]="_data.message"></span>
    }
    @if (_data.listRequired && mergeResponse) {
      @if (mergeResponse.defectiveFiles && mergeResponse.defectiveFiles.length > 0) {
        <div class="file-list">
          <p>
            <strong
              >{{
                'defective_files' | translate: { count: mergeResponse.defectiveFiles.length }
              }}:</strong
            >
          </p>
          <ul>
            @for (file of mergeResponse.defectiveFiles; track file) {
              <li>{{ file }}</li>
            }
          </ul>
        </div>
      }
    }
  </mat-dialog-content>

  <mat-dialog-actions align="center">
    @if (_data.singleButton) {
      <button mat-flat-button (click)="cancelClick()">
        {{ _data.confirmButtonText || 'ok' | translate }}
      </button>
    } @else {
      <button mat-flat-button (click)="cancelClick()">
        {{ _data.cancelButtonText || 'no' | translate }}
      </button>
      <button mat-flat-button (click)="confirmClick()">
        {{ _data.confirmButtonText || 'yes' | translate }}
      </button>
    }
  </mat-dialog-actions>
</div>
